<template>
    <div class="app-container">
        <div
        class="new-container" :class="isCollapse?'new-collapse':''">
            <pang-title :text="$router.lang.get('客服 中心')" eng="Customer Service"/>
            <div class="post-container">
                <div class="input-container">
                    <div class="label">{{ $router.lang.get('分類') }}</div>
                    <div class="input">
                        <select value="100" @input="questionTypeChange">
                            <option v-for="(item, i) in QUESTION_TYPE_CHOICES" :value="i" :key="item">{{ item }}</option>
                        </select>
                    </div>
                </div>
                <div class="input-container text-input">
                    <div class="label">{{ $router.lang.get('主題') }}</div>
                    <div class="input">
                        <pang-input ref="title" required v-model:value="title" :placeholder="$router.lang.get('請輸入文章主題')"/>
                    </div>
                </div>
                <div class="input-container select-input">
                    <div class="label">{{ $router.lang.get('伺服器') }}</div>
                    <div class="input">
                        <select v-model="server">
                            <option value="1">{{ $router.lang.get('全服通用') }}</option>
                        </select>
                    </div>
                </div>
                <div class="input-container">
                    <div class="label">{{ $router.lang.get('角色') }}</div>
                    <div class="input">
                        <pang-input ref="role" v-model:value="role" :placeholder="$router.lang.get('請輸入角色')"/>
                    </div>
                </div>
                <pang-editor ref="content" required :minlength="10" @input="contentInput" :value="content"/>
                <div class="butt-container">
                    <pang-butt @click="cancel" :text="$router.lang.get('取消')" btype="cancel"  :loading="loading"/>
                    <pang-butt @click="submit" :text="$router.lang.get('確認')" btype="submit" :loading="loading"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useScreenState } from '../../store';
import { PangTitle, PangEditor, PangInput, PangButt } from '../../components'
import request from '../../api/request'
import message from '../../utils/message'
import enums from '../../utils/enums'

const SECTIONS = {
    '/question/gamer/new': 1,
    '/question/strategy/new': 2,
    '/question/picture/new': 3,
}

const REPORT_TEMPLATE = '<p>다음 정보를 입력해 주세요.</p>\
<p></p>\
<p>1. 어떤 운영정책을 위반했습니까? : ex)  명칭(캐릭터/ID)에 대한 정책</p>\
<p>2. 신고할 캐릭터명 : </p>\
<p>3. 신고자 캐릭터명 :</p>\
<p>4. 증빙자료 (스크린샷 또는 동영상) : </p>'

const GAME_USAGE_AND_OTHER_TEMPLATE = '<p>안녕하세요! 불편을 끼쳐드려 죄송합니다.</p>\
<p></p>\
<p>다음 정보를 제공해 주시면 빠른 처리가 가능합니다.</p>\
<p></p>\
<p>계정명 :</p>\
<p>서버명(게임명) : </p>\
<p>캐릭터명 :</p>\
<p>문제 발생 시간:</p>\
<p>아이템명:</p>\
<p>상세내용:  (상세히 적어주시면 더욱 빠른 처리가 가능합니다) : </p>'

const RECHARGE_TEMPLATE = '<p>안녕하세요! 불편을 끼쳐드려 죄송합니다.</p>\
<p>다음 정보를 제공해 주시면 빠른 처리가 가능합니다.</p>\
<p>계정명 : </p>\
<p>게임명(서버명) :</p>\
<p>캐릭터명 :</p>\
<p>충전시간:  (월 / 일  시 : 분) :</p>\
<p>충전금액 :</p>\
<p>주문번호(필수기재) : </p>'

export default {
    name: 'Detail',
    components: {
        PangTitle,
        PangEditor,
        PangInput,
        PangButt,
    },
    data () {
        return {
            loading: false,
            screenState: useScreenState(),
            title: '',
            role: '',
            content: GAME_USAGE_AND_OTHER_TEMPLATE,
            question_type: '100',
            server: 1,
            QUESTION_TYPE_CHOICES: enums.QUESTION_TYPE_CHOICES,
            reportStr: REPORT_TEMPLATE,
            gameUsageStr: GAME_USAGE_AND_OTHER_TEMPLATE,
            otherStr: GAME_USAGE_AND_OTHER_TEMPLATE,
            rechargeStr: RECHARGE_TEMPLATE,
            mapping: {
                '100': 'otherStr',
                '2': 'gameUsageStr',
                '4': 'rechargeStr',
                '6': 'reportStr',
            }
        };
    },
    computed: {
        isCollapse() {
            return this.screenState.screenWidth < 900;
        },
    },
    methods: {
        cancel () {
            this.$router.back();
        },
        questionTypeChange (e) {
            if (this.question_type != e.target.value) {
                this[this.mapping[this.question_type]] = this.content
                this.question_type = e.target.value
                this.content = this[this.mapping[this.question_type]]
                this.$refs.content.changeInitValue(this.content)
            }
        },
        async submit () {
            let v1 = await this.$refs.title.validateValue(this.title)
            let v2 = await this.$refs.content.validateValue(this.content)
            if (v1 && v2) {
                let _this = this
                let data = {
                    article: {
                        title: this.title,
                        content: this.content,
                    },
                    server: this.server,
                    role: this.role,
                    section: SECTIONS[this.$route.path],
                    question_type: this.question_type,

                }
                this.loading = true;
                request.post('/questions' , data, _this).then(function (res) {
                    if (res.status == 201) {
                        let url = _this.$route.path.replace(/\/new$/, '/' + res.data.id)
                        _this.$router.replace(url)
                    }
                    else {
                        message.resMessage(res, _this)
                    }
                    _this.loading = true;
                })
            }
        },
        contentInput (e) {
            this.content = e
        }
    },
  beforeMount () {
    if (!this.screenState.user) {
        this.$router.replace({ path: '/account/login', query: {returnurl: this.$route.fullPath}});
    }
  },
}
</script>

<style scoped>

.new-container {
    color: #686A6E;
    margin-bottom: 200px;
}

.post-container {
    max-width: 1040px;
    width: 90vw;
    margin: auto;
}

.input-container {
    display: flex;
    margin: 30px 0;
}

.label  {
    width: 60px;
    line-height: 40px;
}


  select {
    font-size: 16px;
    font-weight: 300;
    color: #999999;
    border: 1px solid #C7C7C7;
    border-radius: 4px;
    background-color: #fff;
    width: 120px;
    height: 40px;
    padding: 0 10px;
  }
  
  select:focus {
    outline: none !important;
    border: 1px solid #C7C7C7;
  }

  .input {
      width: 60%;
  }

.butt-container {
    display: flex;
    max-width: 500px;
    margin-top: 50px;
}

.butt-container > div {
    width: 180px;
    line-height: 40px;
    border-radius: 4px;
    text-align: center;
    color: #FFFFFF;
    font-size: 18px;
    cursor: pointer;
}

.cancel-butt {
    background-color: #DCDCDC;
    margin: auto;
}

.submit-butt {
    background-color: #C6A86C;
    margin: auto;
}

.text-input {
    margin-bottom: 0;
}

.select-input {
    margin-top: 0;
}

.new-collapse .butt-container > div {
    width: calc(10vw + 90px);
}

.new-collapse .label {
    width: calc(1vw + 42px);
}

.new-collapse .input {
    width: 100%;
}

.new-collapse select {
    font-size: calc(1vw + 7px);
    width: 100%;
}

</style>
